import { color } from '@central/ui';
import { Link, useNavigate, useSearch } from '@tanstack/react-router';
import { keys, useApi } from '../../api';
import { resellerTicketKinds } from '../../lib/reports';
import { TicketReportPage } from '../Reports';

/**
 * The reseller's support report: the Rethink report over its own tier 1
 * tickets, with the same filters and downloads.
 */
export function PartnerReports() {
  const api = useApi();
  const navigate = useNavigate({ from: '/partner/reports' });
  const search = useSearch({ from: '/app/partner/reports' });
  return (
    <TicketReportPage
      search={search}
      apply={(next) => void navigate({ search: (s) => ({ ...s, ...next }), replace: true })}
      subtitle="Your tier 1 support tickets reported or resolved in a period (UTC days)"
      queryKey={keys.partnerSupportReport}
      fetch={(q) => api.partner.reports.support(q)}
      csvUrl={(q) => api.partner.reports.supportCsvUrl(q)}
      pdfUrl={(q) => api.partner.reports.supportPdfUrl(q)}
      kinds={resellerTicketKinds}
      customerLink={(id, name) => (
        <Link
          to="/partner/customers/$customerId"
          params={{ customerId: id }}
          style={{ color: color.link }}
        >
          {name}
        </Link>
      )}
    />
  );
}
